// Replace these values with the urls for your application
export const getEnvironment = (): string => {
  const url = window.location.hostname;
  switch (url) {
    case "dtectiondashboard-smk.keoghs.co.uk":
      return "smoke";
    case "dtectiondashboard-uat.keoghs.co.uk":
    case "dtectdashui-uat.uksouth.cloudapp.azure.com":
      return "uat";
    case "dtectiondashboard.keoghs.co.uk":
      return "production";
    default:
      return "local";
  }
};

export default getEnvironment;
